module.exports = __webpack_public_path__ + "img/81.1ca5c3e6.png";